/**
 * Review r8 robustez (B3): uuids reservados. O nil (`00000000-...`) é a sentinela dos índices únicos com
 * `coalesce(coluna, '00000000-...')` (sequências por empresa, centros da folha, saldo por variação e lote): um
 * registro com esse id colidia com "sem valor". O max (`ffffffff-...`) fica reservado pelo mesmo motivo (RFC 9562).
 * A entrada da API e do MCP recusa os dois com 422.
 */
export const UUID_NIL = '00000000-0000-0000-0000-000000000000';
export const UUID_MAX = 'ffffffff-ffff-ffff-ffff-ffffffffffff';

export function ehUuidReservado(v: unknown): boolean {
  if (typeof v !== 'string' || v.length !== 36) return false;
  const x = v.toLowerCase();
  return x === UUID_NIL || x === UUID_MAX;
}

/**
 * Review r28 robustez (B2): o uuid que a entrada da API aceita: o formato do `z.uuid()` do zod (RFC 9562: versão 1 a 8 e
 * variante 8 a b; a mesma regex) e não reservado (`ehUuidReservado`, o saneamento da entrada). O web usa este teste nos
 * filtros da URL: antes aceitava qualquer hex (`12345678-1234-1234-1234-123456789abc`, o nil) e a lista caía em 422.
 */
const RE_UUID_ZOD = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
export function ehUuidAceito(v: unknown): v is string {
  return typeof v === 'string' && RE_UUID_ZOD.test(v) && !ehUuidReservado(v);
}
